<template>
  <div class="safe-area"
    :style="safaStyle">
    <slot name="container" />
  </div>
</template>

<script>
/**
 * props: {
 *  safeHeight: number    额外自增安全距离(按需传入，非必要)
 * }
 */
export default {
  props: {
    safeHeight: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  data() {
    return {

    };
  },
  computed: {
    safaStyle() {
      return this.safeHeight
        ? `padding-bottom: calc(${this.safeHeight + 'px'} + constant(safe-area-inset-bottom)); padding-bottom: calc(${this.safeHeight + 'px'} + env(safe-area-inset-bottom))`
        :              `padding-bottom: constant(safe-area-inset-bottom); padding-bottom: env(safe-area-inset-bottom)`;

    }
  }
};
</script>

<style lang="stylus" scoped>

</style>